import "../App.css";
import { Box, useMediaQuery } from "@mui/material";

const CharacterCustom = ({ isMale, base, eyes, hair, outfit, facialHair, glasses, handleImageLoad }) => {
  const isSmallScreen = useMediaQuery("(max-width: 660px)");

  return (
    <Box className="character">
      <Box className="base">
        <img
          style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
          alt="base"
          src={base && `https://storage.googleapis.com/anekdamian-site/components/base/${base}`}
          className="character-preview-component"
          onLoad={() => handleImageLoad("base")}
        />
      </Box>
      <Box className="eyes">
        <img
          style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
          alt="eyes"
          src={eyes && `https://storage.googleapis.com/anekdamian-site/components/eyes/${eyes}`}
          className="character-preview-component"
          onLoad={() => handleImageLoad("eyes")}
        />
      </Box>
      <Box className="hair">
        <img
          style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
          alt="hair"
          src={hair && `https://storage.googleapis.com/anekdamian-site/components/hair/${hair}`}
          className="character-preview-component"
          onLoad={() => handleImageLoad("hair")}
        />
      </Box>
      <Box className="outfit">
        <img
          style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
          alt="outfit"
          src={outfit && `https://storage.googleapis.com/anekdamian-site/components/outfit/${outfit}`}
          className="character-preview-component"
          onLoad={() => handleImageLoad("outfit")}
        />
      </Box>
      {/* {isMale === "male" && (
        <>
          <Box className="facialHair">
            <img
              style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
              alt="facialHair"
              src={facialHair && `https://storage.googleapis.com/anekdamian-site/components/facial_hair/${facialHair}`}
              className="character-preview-component"
              onLoad={() => handleImageLoad("facial_hair")}
            />
          </Box>
          <Box className="glasses">
            <img
              style={{ maxWidth: isSmallScreen ? "310px" : "350px" }}
              alt="glasses"
              src={glasses && `https://storage.googleapis.com/anekdamian-site/components/glasses/${glasses}`}
              className="character-preview-component"
              onLoad={() => handleImageLoad("glasses")}
            />
          </Box>
        </>
      )} */}
    </Box>
  );
};

export default CharacterCustom;
